import React from 'react';
import { Typography, Button } from '@material-ui/core';
import styled from 'styled-components';
import { DialogBox } from '../Dialog';
import defaults from './en';
export const RecordVisitButtonsDiv = styled.div.withConfig({
  displayName: "ConfimStickyDialog__RecordVisitButtonsDiv",
  componentId: "sc-1u7swld-0"
})(["display:flex;flex-direction:row;justify-content:end;gap:20px;margin:1rem;"]);
export const ConfirmStickyDialog = ({
  open,
  onSubmit,
  onCancel
}) => /*#__PURE__*/React.createElement(DialogBox, {
  title: defaults.stickyTitle,
  handleClick: () => null,
  open: open,
  noIcon: true
}, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, defaults.confirmSubmit), /*#__PURE__*/React.createElement(RecordVisitButtonsDiv, null, /*#__PURE__*/React.createElement(Button, {
  size: "small",
  variant: "contained",
  color: "primary",
  onClick: onCancel
}, defaults.review), /*#__PURE__*/React.createElement(Button, {
  size: "small",
  variant: "contained",
  color: "primary",
  onClick: onSubmit
}, defaults.submit))));